<template>
  <div class="text-center">
    <div class="flex justify-center">
      <div
        class="h-[2px] bg-gray-300 font-black border-0 relative top-[1.45em] w-16"
        :class="currentStep > 0 ? 'bg-cyan-700' : 'bg-gray-300 '"
      ></div>
      <div
        class="h-[2px] bg-gray-300 font-black border-0 relative top-[1.45em] w-16"
        :class="currentStep > 1 ? 'bg-cyan-700' : 'bg-gray-300 '"
      ></div>
    </div>
    <div v-for="(step, index) in steps" :key="index" class="inline-grid gap-3">
      <div class="w-16 text-center m-2 items-center">
        <div
          class="size-8 rounded-full border-[1.5px] border-brand-600 text-center p-1 relative left-4"
          :class="currentStep === index || index < currentStep ? 'bg-brand-600' : 'bg-base-white'"
        >
          <p v-if="index < currentStep" class="text-base-white">&#10003;</p>
          <span
            v-else
            class="font-bold inline-block align-middle text-sm"
            :class="currentStep === index || index < currentStep ? 'text-base-white' : 'text-brand-600'"
          >
            {{ step.number }}
          </span>
        </div>
        <span class="text-[11px] text-gray-500">{{ step.name }}</span>
      </div>
    </div>
    <SectionDivider />
  </div>
</template>

<script setup lang="ts">
import SectionDivider from './SectionDivider.vue';

defineProps<{
  currentStep: number;
  steps: { name: string; number: string }[];
}>();
</script>
